import React from 'react';
import { Row, Separator } from '@cuemath/comps';
import {
  Affordance,
  Chip,
  Tile,
  TileCaption,
  TileHead,
  TileLabel,
  TileMain,
  TileRow,
  TileShell,
  TileValue,
} from '../styled-comps';
import { MODAL_KIND, RESOLUTION_BUCKETS } from '../constants';
import InfoTip from './info';

/**
 * Two behaviours, and they must be told apart before the click: a tile that
 * has a pane below scrolls to it; one that doesn't opens a modal. The
 * affordance text carries that — "↓ pane" versus "open list ↗".
 */
const Tiles = ({ tiles, onJumpToPane, onOpenModal }) => {
  const resolved = tiles.resolved || {};
  const unassignedHot = tiles.unassigned > 0;

  return (
    <TileRow>
      <Tile type="button" onClick={() => onOpenModal({ kind: MODAL_KIND.TOTAL })}>
        <TileHead>
          <TileLabel>Total live</TileLabel>
          <InfoTip topic="total" />
          <Affordance>open list ↗</Affordance>
        </TileHead>
        <TileValue>{tiles.total_live}</TileValue>
        <TileCaption>{tiles.created_in_window} opened in window</TileCaption>
      </Tile>

      <Tile type="button" onClick={() => onJumpToPane('bot')}>
        <TileHead>
          <TileLabel>With the bot</TileLabel>
          <InfoTip topic="bot" />
          <Affordance>↓ pane</Affordance>
        </TileHead>
        <TileValue>{tiles.bot}</TileValue>
        <TileCaption>no human involved yet</TileCaption>
      </Tile>

      <Tile type="button" $hot={unassignedHot} onClick={() => onJumpToPane('unassigned')}>
        <TileHead>
          <TileLabel>Unassigned</TileLabel>
          <InfoTip topic="unassigned" />
          <Affordance>↓ pane</Affordance>
        </TileHead>
        <TileValue $hot={unassignedHot}>{tiles.unassigned}</TileValue>
        <TileCaption>
          {unassignedHot ? 'waiting for someone to pick up' : 'queue clear'}
        </TileCaption>
      </Tile>

      <Tile type="button" onClick={() => onJumpToPane('agent')}>
        <TileHead>
          <TileLabel>With an agent</TileLabel>
          <InfoTip topic="agent" />
          <Affordance>↓ pane</Affordance>
        </TileHead>
        <TileValue>{tiles.agent}</TileValue>
        <TileCaption>{tiles.awaiting_first_reply} awaiting first reply</TileCaption>
      </Tile>

      <TileShell>
        <TileMain
          type="button"
          onClick={() => onOpenModal({ kind: MODAL_KIND.RESOLVED })}
        >
          <TileHead>
            <TileLabel>Resolved</TileLabel>
            <InfoTip topic="resolved" />
            <Affordance>open list ↗</Affordance>
          </TileHead>
          <TileValue>{resolved.total}</TileValue>
        </TileMain>
        <Separator height={6} transparent />
        <Row gutter={0} gap={4}>
          {RESOLUTION_BUCKETS.map(b => (
            <Chip
              key={b.key}
              type="button"
              title={`Open the ${b.label.toLowerCase()} list`}
              onClick={() => onOpenModal({ kind: MODAL_KIND.RESOLVED, bucket: b.key })}
            >
              <span>{b.label}</span>
              <strong>{resolved[b.key]}</strong>
            </Chip>
          ))}
        </Row>
      </TileShell>
    </TileRow>
  );
};

export default Tiles;
